import {Card} from 'antd';
import React from 'react';
import {Route, Switch} from 'react-router';
import EmpresaContratosDetailPage from './_detail';
import EmpresaContratoPage from './contrato';

export default function EmpresaContratosPage() {
  return (
      <Card bordered={false}>
        <Switch>
          <Route path="/*/empresas/:empresaId/contratos/:id" component={EmpresaContratoPage} />
          <Route path="/*/empresas/:empresaId" component={EmpresaContratosDetailPage} />
        </Switch>
      </Card>);
}
